import React, { createContext, useEffect, useMemo, useState } from 'react';
import { type ControllableElement } from '@bynder-studio/render-core';
import useDesign from '../hooks/useDesign';

type ContextData = {
    selectedElement: ControllableElement | null;
};

export const DesignSelectedElementContext = createContext({} as ContextData);

export function DesignSelectedElementProvider({ children }) {
    const { canvasRenderer } = useDesign();
    const [selectedElement, setSelectedElement] = useState<ControllableElement | null>(
        canvasRenderer?.getSelectedElement() ?? null,
    );

    useEffect(() => {
        if (!canvasRenderer) {
            return;
        }

        const onElementSelected = () => {
            setSelectedElement(canvasRenderer.getSelectedElement());
        };

        canvasRenderer.eventEmitter.on('elementSelected', onElementSelected);

        return () => {
            canvasRenderer.eventEmitter.off('elementSelected', onElementSelected);
        };
    }, [canvasRenderer]);

    const value = useMemo(() => ({ selectedElement }), [selectedElement]);

    return <DesignSelectedElementContext.Provider value={value}>{children}</DesignSelectedElementContext.Provider>;
}
